import {Component, Input, OnInit} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatCard, MatCardActions, MatCardContent, MatCardTitle} from '@angular/material/card';
import {MatDialog} from '@angular/material/dialog';
import {AssetService, GroupAsset} from '@app/asset';
import {EditGroupDialogComponent} from '@app/group/edit-group-dialog/edit-group-dialog.component';
import {GroupService} from '@app/group/group.service';
import {User} from '@app/shared/user.service';
import {InspectorService} from '../inspector.service';

@Component({
    selector: 'frog-group-inspector',
    templateUrl: './group-inspector.component.html',
    styleUrls: ['./group-inspector.component.scss'],
    imports: [MatCard, MatCardTitle, MatCardContent, MatCardActions, MatButton],
})
export class GroupInspectorComponent implements OnInit {
    @Input() asset: GroupAsset;
    @Input() user: User;

    public confirm: boolean;

    constructor(
        private groupService: GroupService,
        private inspectorService: InspectorService,
        private assetService: AssetService,
        private matDialog: MatDialog,
    ) {
        this.confirm = false;
    }

    ngOnInit(): void {}

    editGroup() {
        this.matDialog.open(EditGroupDialogComponent, { data: this.asset });
    }

    ungroup() {
        this.groupService.ungroup(this.asset.id).subscribe(() => {
            this.inspectorService.inspect(null);
            this.assetService.filter(true);
        });
    }
}
